import { Link } from "react-router-dom";
import RowSalonListData from "../common/RowSalonListData";
import FlexTable from "../common/FlexTable";
import { location } from "../../../types/calendar";

type Props = {
  locations: location[];
};

const TopPerformingSalons = ({ locations }: Props) => {
  const cols = ["Salon Name", "Appointments", "Ratings"];
  console.log(locations, "locations");
  return (
    <div className="w-full h-full bg-white p-6 rounded-lg flex flex-col gap-8">
      <div className="w-full flex items-center justify-between">
        <h4 className="text-color-primary text-lg font-semibold">
          Top performing salons
        </h4>
        <Link
          className="text-color-primary px-4 py-2 rounded-2xl bg-[#EEF0FF] font-medium text-sm"
          to="/admin/salon-management"
        >
          See all
        </Link>
      </div>
      <div>
        <FlexTable
          cols={cols}
          data={locations || []}
          isDivider={false}
          type="appointment"
          maxCount={8}
        />
      </div>
    </div>
  );
};

export default TopPerformingSalons;
